import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default new VueI18n({
  fallbackLocale: 'en',
  locale: 'my',
  messages: {
    'en': require('../locales/en.json'),
    'my': require('../locales/my.json'),
    'cn': require('../locales/cn.json')
  }
})
